import { authErrorHandler } from '@/services/error/authHandler.js';
import { getUserFriendlyErrorMessage } from '@/utils/errorHandler.js';
import router from '@/router';

export default {
  fetchSiwfData({ commit }, payload) {
    try {
      const siwfData = getUserHandle(commit, payload).then(data => data);
      return siwfData;
    } catch (error) {
      const friendlyMessage = getUserFriendlyErrorMessage(error);
      console.error('Error fetching SIWF data from cookie:', friendlyMessage);
      
      // In development, also log the original error for debugging
      if (import.meta.env.MODE === 'development') {
        console.error('Original SIWF error:', error);
      }
      
      authErrorHandler(error);
      return null;
    }
  },
};

async function getUserHandle(commit, payload) {
  const { fromUsername, toUsername } = payload || {};
  if (!fromUsername || !toUsername)
    return null;

  const usernameQuery = fromUsername && toUsername ? `?fromUsername=${encodeURIComponent(fromUsername)}&toUsername=${toUsername}` : '';
  const response = await fetch(`/api/siwf/handle${usernameQuery}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
    },
    credentials: 'include',
  });

  if (!response) {
    const error = new Error('No response received');
    throw new Error(error.message || 'failed to get user frequency handle.');
  }

  const siwfData = await response.json();
    if (siwfData?.message === "User account is deleted" || siwfData?.message === "User no longer exists" || siwfData?.message === "Unauthorized" ) {
      await fetch("/api/auth/logout", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      localStorage.removeItem("user");
      localStorage.removeItem("activeTab");
      commit("setAuthStatus", false);
      await router.push("/");
      return;
    }
  commit('setSiwfData', siwfData);
  localStorage.setItem('userFrequencyHandle', siwfData?.userDetails?.frequencyHandle.baseHandle);

  return siwfData;
}
